// extracted by mini-css-extract-plugin
export default {"stack":"SlugTiming_stack__yAeAl","scroll":"SlugTiming_scroll__p47M-","divider":"SlugTiming_divider__g0QY5"};